import { useState } from "react";

import TabButton from "../../../../../../../Components/common/TabButton/TabButton";
import NotificationHeader from "../../NotificationHeader";
import Telegram from "./Telegram";
import Slack from "./Slack";

import "./styles.scss";

const SocialNotification = ({ selectedNotification }) => {
  const [active, setActive] = useState("Telegram");

  return (
    <>
      <div className="button-block">
        <TabButton title="Telegram" onClick={setActive} active={active} />
        <TabButton title="Slack" onClick={setActive} active={active} />
      </div>
      <NotificationHeader
        selectedNotification={selectedNotification}
        toggleProps={{
          show: false,
        }}
      />
      <div className="social__content">
        {active === "Telegram" ? <Telegram /> : active === "Slack" ? <Slack /> : null}
      </div>
    </>
  );
};

export default SocialNotification;
